import { TableItemListStyled } from "./TableItemStyled";
import { Layout } from "react-grid-layout";
import {
  ProfileAccountInfo,
} from "api/interfaces/accountInterface.interface";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { useAppSelector } from "redux/hooks";
import {
  isDisabledDashboardTableList,
  tableItemList,
  TableItemName,
} from "utils/WidgetUtil";

interface Props {
  layout: Layout;
  chartLayout: Layout[];
  onDeleteWidget: (key: TableItemName) => void;
  onLayoutChange: (layout: Layout[]) => void;
}

export default function TableItemList(props: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  return (
    <TableItemListStyled.Container>
      {Object.entries(tableItemList)
        .filter(
          (fil) =>
            !props.chartLayout.map((ch) => ch.i).includes(fil[0]) &&
            (selectedAccount.accountLevel !== LEVEL_TYPE.EU
              ? fil[0] !== "recorder"
              : true)
        )
        .map((item) => {
          return (
            <TableItemListStyled.Item
              key={`layout-item-${item[0]}`}
              isDisabled={isDisabledDashboardTableList.includes(item[0])}
              onClick={() => {
                if (isDisabledDashboardTableList.includes(item[0])) {
                  return;
                }
                let tempLayouts: Layout[] = props.chartLayout.map((lay) => {
                  if (lay.i === props.layout.i) {
                    return {
                      ...lay,
                      i: item[0],
                    };
                  } else return lay;
                });
                props.onLayoutChange(tempLayouts);
              }}
              data-testid="dashboard-dashboard-table-item-includes"
            >
              {item[1]}
            </TableItemListStyled.Item>
          );
        })}
      <TableItemListStyled.Item
        onClick={() => {
          props.onDeleteWidget(props.layout.i as TableItemName);
        }}
        data-testid="dashboard-dashboard-table-item-delete-widget"
      >
        Remove Widget
      </TableItemListStyled.Item>
    </TableItemListStyled.Container>
  );
}
